import { useState } from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';
import { CreateUserForm } from '@/components/users/CreateUserForm';
import { UsersTable } from '@/components/users/UsersTable';
import { useUsers } from '@/hooks/users';

export default function UsersPage() {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const { data, isLoading, isError } = useUsers();

  return (
    <div className='p-4 sm:p-6 lg:p-8 max-w-5xl mx-auto flex flex-col gap-6'>
      <div className='flex items-center justify-between'>
        <div>
          <p className='text-[11px] font-bold tracking-[0.15em] uppercase mb-1' style={{ color: 'oklch(0.65 0.22 285)' }}>
            Admin
          </p>
          <h1 className='text-2xl font-bold font-syne'>Users</h1>
        </div>
        {!showCreateForm && (
          <Button onClick={() => setShowCreateForm(true)}>Add User</Button>
        )}
      </div>

      {showCreateForm && (
        <CreateUserForm
          onCreated={() => setShowCreateForm(false)}
          onCancel={() => setShowCreateForm(false)}
        />
      )}

      {isError && (
        <Alert variant='destructive'>
          <AlertCircle className='h-4 w-4' />
          <AlertDescription>Failed to load users.</AlertDescription>
        </Alert>
      )}

      <UsersTable users={data?.users ?? []} isLoading={isLoading} />
    </div>
  );
}
